import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCity = async (params: object) => {
  return await GET({ url: Api.getCity, params, showError: false })
}
export const submitCity = async (params: object) => {
  return await POST({ url: Api.submitCity, params, showError: false })
}
